<script>
export default {
  name: 'InlineSvg',
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      svgContent: '',
    };
  },
  async mounted() {
    await this.loadSvg();
  },
  methods: {
    async loadSvg() {
      try {
        // 直接使用传入的完整路径获取 SVG 内容
        const response = await fetch(this.src);
        let svgText = await response.text();

        // 处理 SVG 以支持 currentColor
        svgText = this.processSvg(svgText);

        // 更新 SVG 内容
        this.svgContent = svgText;
      } catch (error) {
        console.error('Failed to load SVG:', error);
      }
    },

    processSvg(svgText) {
      // 移除外层可能存在的额外包装
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgText, 'image/svg+xml');
      const svgElement = doc.querySelector('svg');

      if (svgElement) {
        // 确保 preserveAspectRatio 属性存在
        if (!svgElement.getAttribute('preserveAspectRatio')) {
          svgElement.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        }

        // 遍历所有元素，将 fill 和 stroke 替换为 currentColor
        const elements = svgElement.querySelectorAll('*');
        elements.forEach((el) => {
          const fill = el.getAttribute('fill');
          const stroke = el.getAttribute('stroke');

          if (fill && fill !== 'none') {
            el.setAttribute('fill', 'currentColor');
          }
          if (stroke && stroke !== 'none') {
            el.setAttribute('stroke', 'currentColor');
          }
        });

        // 同时也检查 svg 根元素
        const rootFill = svgElement.getAttribute('fill');
        const rootStroke = svgElement.getAttribute('stroke');
        if (rootFill && rootFill !== 'none') {
          svgElement.setAttribute('fill', 'currentColor');
        }
        if (rootStroke && rootStroke !== 'none') {
          svgElement.setAttribute('stroke', 'currentColor');
        }

        return svgElement.outerHTML;
      }

      return svgText;
    },
  },
  watch: {
    src: {
      handler() {
        this.loadSvg();
      },
    },
  },
  render(h) {
    // 直接渲染 SVG 内容，不使用额外的包装元素
    if (this.svgContent) {
      // 创建一个临时 div 来解析 SVG 字符串
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.svgContent;
      const svgEl = tempDiv.querySelector('svg');

      if (svgEl) {
        // 构建属性对象，包含所有传入的属性
        const attrs = {};

        // 复制 SVG 元素原有的属性
        for (let i = 0; i < svgEl.attributes.length; i++) {
          const attr = svgEl.attributes[i];
          attrs[attr.name] = attr.value;
        }

        // 处理 class 属性的合并
        if (this.$attrs.class) {
          attrs.class = attrs.class
            ? `${attrs.class} ${this.$attrs.class}`
            : this.$attrs.class;
        }

        for (const key in this.$attrs) {
          // 跳过 class 属性，因为已特殊处理
          if (key === 'class') continue;
          // 将驼峰命名转换为短横线命名
          const attrName = key.replace(/([A-Z])/g, '-$1').toLowerCase();
          attrs[attrName] = this.$attrs[key];
        }

        // 返回 SVG VNode
        return h('svg', {
          attrs: { ...attrs },
          domProps: {
            innerHTML: svgEl.innerHTML,
          },
        });
      }
    }

    // 如果没有内容，返回空的 SVG 元素，但仍透传属性
    const attrs = {};

    // 处理 class 属性
    if (this.$attrs.class) {
      attrs.class = this.$attrs.class;
    }

    // 透传组件接收到的所有属性（除了 src 和 className）
    for (const key in this.$attrs) {
      // 跳过 class 属性，因为已特殊处理
      if (key === 'class') continue;
      // 将驼峰命名转换为短横线命名
      const attrName = key.replace(/([A-Z])/g, '-$1').toLowerCase();
      attrs[attrName] = this.$attrs[key];
    }

    return h('svg', { attrs });
  },
};
</script>
